import React, {useCallback, useEffect, useRef, useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Tooltip, zIndex} from '@optimaxdev/design-system';
import classNames from 'classnames';

import {CHECKOUT_GENERAL} from 'constants/analytics/events/checkout';

import {TOOLTIP_NAME} from '../../constants/deliveryStep';

import s from './digicertIconTooltip.scss';

/**
 * Digicert Icon Tooltip, it's wrapper up to digicert for render tooltip
 *
 * @constructor
 */
export const DigicertIconTooltip = () => {
    const [isTooltipVisible, setTooltipVisibility] = useState<boolean>(false);
    const toggleTooltip = useCallback(
        () => setTooltipVisibility(!isTooltipVisible),
        [isTooltipVisible, setTooltipVisibility],
    );

    const timeout = useRef<number>();

    useEffect(() => {
        if (isTooltipVisible) {
            timeout.current = window.setTimeout(() => {
                sendDesktopAnalyticsEvent(CHECKOUT_GENERAL, {
                    message: `${TOOLTIP_NAME} - Hover`,
                });
            }, 3000);
        }
        return () => clearTimeout(timeout.current);
    }, [isTooltipVisible]);

    return (
        <Tooltip
            content={
                <div className={s.tooltip}>
                    <span className={s.tooltipTitle}>Shop with Confidence</span>
                    <p className={s.tooltipContent}>
                        Shopping with us is safe and secured. Guaranteed! All information is
                        encrypted and transmitted using a secured SSL protocol.
                    </p>
                </div>
            }
            closeTrigger="hover"
            isOpen={isTooltipVisible}
            onChange={toggleTooltip}
            openTrigger="hover"
            position="bottom-end"
            tooltipAnimation="fastMoving"
            zIndex={zIndex.tooltip}
        >
            <div aria-label={`${TOOLTIP_NAME} Secured`} className={s.icon}>
                <div className={classNames(s.digicertSecured)} role="presentation" />
            </div>
        </Tooltip>
    );
};
